import { render, staticRenderFns } from "./VideoRecordIcon.vue?vue&type=template&id=1fc13453&"
import script from "./VideoRecordIcon.vue?vue&type=script&lang=js&"
export * from "./VideoRecordIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports